export default {
  title: 'Area | Areas',
  buttons: {
    create: 'Create area',
    edit: 'Edit area',
    delete: 'Delete areas',
    actions: {
      close: 'Close',
      save: 'Save',
      yes: 'Yes',
      no: 'No'
    }
  },
  labels: {
    createArea: 'Create area',
    editArea: 'Edit area',
    deleteArea: 'Delete area',
    areaName: 'Area name'
  },
  tables: {
    title: 'areas',
    loadingMessage: 'Loading areas...',
    headers: {
      areaName: 'Area name',
      actions: 'Actions'
    },
    noData: 'Areas not found'
  },
  tooltips: {
    createArea: 'Create area',
    edit: 'Edit area',
    delete: 'Delete area'
  },
  placeholders: {
    areaName: 'Area name'
  },
  alerts: {
  },
  validations: {
  },
  tabs: {
  }
}
